import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3a1 1 0 00-1-1H7a1 1 0 00-1 1v11H1.5a.5.5 0 000 1h12a.5.5 0 000-1H9V3z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgAlignBottom = styled(BaseComponent)`
  outline: none;
`
export default SvgAlignBottom
